import React from "react";
import { statusFields } from "../../../utils/fields";

export type AdminBadgeTone = "neutral" | "success" | "warning" | "danger" | "info" | "gold" | "dark";

const tones: { [key in AdminBadgeTone]: { badge: string, dot: string } } = {
    neutral: { badge: "bg-gray-100 text-gray-700 ring-gray-500/20", dot: "bg-gray-400" },
    success: { badge: "bg-emerald-50 text-emerald-700 ring-emerald-600/20", dot: "bg-emerald-500" },
    warning: { badge: "bg-amber-50 text-amber-800 ring-amber-600/25", dot: "bg-amber-500" },
    danger: { badge: "bg-red-50 text-red-700 ring-red-600/20", dot: "bg-red-500" },
    info: { badge: "bg-sky-50 text-sky-700 ring-sky-600/20", dot: "bg-sky-500" },
    gold: { badge: "bg-secondary/10 text-secondary-dark ring-secondary/30", dot: "bg-secondary" },
    dark: { badge: "bg-gray-900 text-white ring-gray-900", dot: "bg-white" },
}

export default function AdminBadge({ tone = "neutral", dot = false, children, className = "" }: { tone?: AdminBadgeTone, dot?: boolean, children: React.ReactNode, className?: string }) {
    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset whitespace-nowrap ${tones[tone].badge} ${className}`}>
            {
                dot ?
                    <span className={`h-1.5 w-1.5 rounded-full ${tones[tone].dot}`} />
                    : null
            }
            {children}
        </span>
    )
}

// tom visual de cada status de relógio (watches.status)
export const watchStatusTones: { [key: string]: AdminBadgeTone } = {
    draft: "neutral",
    approval: "warning",
    display: "success",
    sold: "info",
    hidden: "danger",
}

export function WatchStatusBadge({ status }: { status: string | undefined }) {
    if (!status) {
        return <span className="text-gray-400">—</span>;
    }
    return (
        <AdminBadge tone={watchStatusTones[status] || "neutral"} dot>{statusFields[status] || status}</AdminBadge>
    )
}

// bolinha numérica para abas, menu e contadores
export function AdminCount({ count, tone = "neutral" }: { count: number, tone?: "neutral" | "danger" | "gold" }) {
    const colors = tone === "danger" ? "bg-red-500 text-white" : tone === "gold" ? "bg-secondary text-white" : "bg-gray-200 text-gray-700";
    return (
        <span className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] font-bold tabular-nums ${colors}`}>{count}</span>
    )
}
